import {
    type DeleteFormResponseType,
    type DeleteFormRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteForm = async (params: DeleteFormRequestType): Promise<DeleteFormResponseType> => {
    return await request<DeleteFormResponseType>(`/events/deleteForm?formID=${params.formID}`, {
        method: "DELETE"
    });
};

export default DeleteForm;
